import React, { useState } from "react";
import "../../styles/EduComponents/ContactUsForm.css";

const ContactUsForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    academyType: "",
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "+91",
    phone: "",
    country: "India",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const scriptURL = process.env.REACT_APP_CONTACT_SCRIPT_URL;

  //   const formBody = new URLSearchParams();
  //   Object.entries(formData).forEach(([key, value]) => {
  //     formBody.append(key, value);
  //   });

  //   try {
  //     const response = await fetch(scriptURL, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },
  //       body: formBody.toString(),
  //     });

  //     const result = await response.json();

  //     if (result.status === "success") {
  //       alert("Submitted successfully!");
  //       setFormData({
  //         academyType: "",
  //         firstName: "",
  //         lastName: "",
  //         email: "",
  //         phone: "",
  //         countryCode: "+91",
  //         country: "India",
  //         message: "",
  //       });
  //     } else {
  //       alert("Error: " + result.message);
  //     }
  //   } catch (error) {
  //     alert("Submission failed. Please try again.");
  //     console.error("Error:", error);
  //   }
  // };


  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  setSuccessMessage("");

  const scriptURL = process.env.REACT_APP_CONTACT_SCRIPT_URL;

  const formBody = new URLSearchParams();
  Object.entries(formData).forEach(([key, value]) => {
    formBody.append(key, value);
  });

  try {
    const response = await fetch(scriptURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formBody.toString(),
    });

    const result = await response.json();

    if (result.status === "success") {
      setSuccessMessage("Your message has been sent successfully!");
      setFormData({
        academyType: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        countryCode: "+91",
        country: "India",
        message: "",
      });

      setTimeout(() => {
        setSuccessMessage("");
      }, 4000);
    } else {
      setSuccessMessage("Something went wrong. Please try again.");
    }
  } catch (error) {
    setSuccessMessage("Submission failed. Please try again.");
  }

  setIsSubmitting(false);
};

  const countryData = [
    { name: "Afghanistan", code: "AF", dial_code: "+93" },
    { name: "Albania", code: "AL", dial_code: "+355" },
    { name: "Algeria", code: "DZ", dial_code: "+213" },
    { name: "Andorra", code: "AD", dial_code: "+376" },
    { name: "Angola", code: "AO", dial_code: "+244" },
    { name: "Argentina", code: "AR", dial_code: "+54" },
    { name: "Australia", code: "AU", dial_code: "+61" },
    { name: "Austria", code: "AT", dial_code: "+43" },
    { name: "Bangladesh", code: "BD", dial_code: "+880" },
    { name: "Belgium", code: "BE", dial_code: "+32" },
    { name: "Bhutan", code: "BT", dial_code: "+975" },
    { name: "Brazil", code: "BR", dial_code: "+55" },
    { name: "Canada", code: "CA", dial_code: "+1" },
    { name: "China", code: "CN", dial_code: "+86" },
    { name: "Denmark", code: "DK", dial_code: "+45" },
    { name: "Egypt", code: "EG", dial_code: "+20" },
    { name: "France", code: "FR", dial_code: "+33" },
    { name: "Germany", code: "DE", dial_code: "+49" },
    { name: "India", code: "IN", dial_code: "+91" },
    { name: "Indonesia", code: "ID", dial_code: "+62" },
    { name: "Italy", code: "IT", dial_code: "+39" },
    { name: "Japan", code: "JP", dial_code: "+81" },
    { name: "Mexico", code: "MX", dial_code: "+52" },
    { name: "Nepal", code: "NP", dial_code: "+977" },
    { name: "Netherlands", code: "NL", dial_code: "+31" },
    { name: "New Zealand", code: "NZ", dial_code: "+64" },
    { name: "Pakistan", code: "PK", dial_code: "+92" },
    { name: "Singapore", code: "SG", dial_code: "+65" },
    { name: "South Africa", code: "ZA", dial_code: "+27" },
    { name: "Spain", code: "ES", dial_code: "+34" },
    { name: "Sri Lanka", code: "LK", dial_code: "+94" },
    { name: "Sweden", code: "SE", dial_code: "+46" },
    { name: "Switzerland", code: "CH", dial_code: "+41" },
    { name: "Thailand", code: "TH", dial_code: "+66" },
    { name: "Turkey", code: "TR", dial_code: "+90" },
    { name: "United Arab Emirates", code: "AE", dial_code: "+971" },
    { name: "United Kingdom", code: "GB", dial_code: "+44" },
    { name: "United States", code: "US", dial_code: "+1" },
    // Add more as needed...
  ];

  return (
    <div className="contact-form-section">
      <h2 className="contact-title">
        Contact <span>Us</span>
      </h2>
      <p className="contact-subtitle">Contact us today and get started!</p>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="academyType">Academy Type</label>
          <select
            name="academyType"
            value={formData.academyType}
            onChange={handleChange}
            required
            className="form-input"
          >
            <option value="">Select One...</option>
            <option value="Chess Academy">Chess Academy</option>
            <option value="Music Academy">Music Academy</option>
            <option value="Robotics Academy">Robotics Academy</option>
            <option value="Tutoring Academy">Tutoring Academy</option>
            <option value="Others">Others</option>
          </select>
        </div>

        <div className="input-row">
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              onChange={handleChange}
              value={formData.firstName}
              required
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              onChange={handleChange}
              value={formData.lastName}
              required
              className="form-input"
            />
          </div>
        </div>

        <div className="input-row">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              value={formData.email}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number (Optional)</label>
            <div className="phone-input-group">
              <select
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
              >
                <option value="">Code</option>
                {countryData.map((country, index) => (
                  <option key={index} value={country.dial_code}>
                    {country.dial_code} ({country.code})
                  </option>
                ))}
              </select>
              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                onChange={handleChange}
                value={formData.phone}
                pattern="\d{10}"
                maxLength="10"
                inputMode="numeric"
                className="form-input"
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="country">Country</label>
          <select
            name="country"
            value={formData.country}
            onChange={handleChange}
            required
            className="form-input"
          >
            <option value="">Select One...</option>
            {countryData.map((country, index) => (
              <option key={index} value={country.name}>
                {country.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
  <label htmlFor="message">Message</label>
  <textarea
    name="message"
    placeholder="Write your message here..."
    value={formData.message}
    onChange={handleChange}
    rows="4"
    className="form-input"
    required
  ></textarea>
</div>


        <div className="contact2">
          <button 
  type="submit" 
  className="button2"
  disabled={isSubmitting}
>
  {isSubmitting ? "Submitting..." : "Submit"}
</button>
        </div>

        {successMessage && (
  <div className="success-popup">
    {successMessage}
  </div>
)}
      </form>
    </div>
  );
};

export default ContactUsForm;
